import { useEffect, useState } from "react";

const RotateDevicePopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;

      const isTablet = width >= 768 && width <= 1024;
      const isPortrait = height > width;

      setShowPopup(isTablet && isPortrait);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  if (!showPopup) return null;

  return (
    <div className="rotate-popup">
      <div className="rotate-box">
        <h3>Please rotate your device</h3>
        <p>For better experience, use landscape mode.</p>
      </div>
    </div>
  );
};

export default RotateDevicePopup;